import { render } from "./ManifestoComponent.vue?vue&type=template&id=23312ada&scoped=true"
import script from "./ManifestoComponent.vue?vue&type=script&lang=js"
export * from "./ManifestoComponent.vue?vue&type=script&lang=js"

import "./ManifestoComponent.vue?vue&type=style&index=0&id=23312ada&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23312ada"]])

export default __exports__